module.exports = __webpack_public_path__ + "static/media/broccolilemonaglioolio.c13035d8.jpg";